<template>
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M10.3333 3.50861C10.3333 3.7242 10.2537 3.93978 10.0939 4.10428L6.30831 7.99996L10.0939 11.8956C10.413 12.2246 10.413 12.758 10.0939 13.087C9.77421 13.4154 9.25601 13.4154 8.93637 13.087L4.57264 8.59562C4.25354 8.26663 4.25354 7.73328 4.57264 7.40429L8.93637 2.91295C9.25602 2.58452 9.77421 2.58452 10.0939 2.91295C10.2537 3.07744 10.3333 3.29303 10.3333 3.50861Z"
      fill=""
    />
  </svg>
</template>
